import React from 'react';
import { ApolloProvider } from '@apollo/client/react';
import client from "./src/components/apollo_utils/client";
import "@fortawesome/fontawesome-svg-core/styles.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import "./global.scss";
import Main from './src/components/main';

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>
    <Main>
      {element}
    </Main>
  </ApolloProvider>  
);